export const importTextFile = (callback) => {
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.accept = '.txt';
  fileInput.onchange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
      callback(event.target.result);
    };
    reader.readAsText(file);
  };
  fileInput.click();
};

export const copyToClipboard = (text) => {
  return navigator.clipboard.writeText(text);
};

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const parseMultilineInput = (text) => {
  if (!text) return [];
  
  return text
    .split('\n')
    .map(line => line.trim())
    .filter(line => line.length > 0);
};